import { useQuery } from '@tanstack/react-query'
import { outputSchema } from '../../graphql/recommended-query/schema'

export const useInferredGqlQuery = ({
  teamSlug,
  repoSlug,
  token,
  commitId,
}: {
  teamSlug: string
  repoSlug: string
  token: string
  commitId: string
}) => {
  return useQuery(
    [`inferred-gql-query`, token, commitId],
    async () => {
      const res = await fetch(
        `/${teamSlug}/${repoSlug}/graphql/recommended-query?token=${token}&ref=${commitId}`
      )
      if (res.status === 200) {
        const json = await res.json()
        return outputSchema.parse(json)
      } else {
        throw new Error(res.statusText)
      }
    },
    {
      enabled: !!token && !!commitId && false,
      staleTime: Infinity,
    }
  )
}
